module.exports = "<svg id=\"close_btn\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48.35 48.31\"><title></title><circle cx=\"23.87\" cy=\"24.23\" r=\"23.03\" style=\"fill:#ffae2e\"></circle><path d=\"M36,34,32.31,37.4,24,28.53l-8.18,9-3.7-3.37,8.45-9.26L12,15.7l3.65-3.41L24,21.16l8.2-9,3.69,3.37-8.47,9.29Z\" style=\"fill:#fff;fill-rule:evenodd\"></path><path d=\"M24.18,0A24.16,24.16,0,1,0,48.35,24.15,24.16,24.16,0,0,0,24.18,0Zm0,46.31A22.16,22.16,0,1,1,46.35,24.15,22.19,22.19,0,0,1,24.18,46.31Z\" style=\"fill:#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/svg/close_btn_orange.svg
// module id = 69n1
// module chunks = 0